import type {ThemingProps, HTMLChakraProps} from '@chakra-ui/system';
import {forwardRef, omitThemingProps} from '@chakra-ui/system';
import {ChakraP} from '@linx-security/ui/utils/chakra-elements';

import {textAnatomy, useTextStyleConfig} from './theme';

export const Text = forwardRef((props: HTMLChakraProps<`p`> & ThemingProps, ref) => {
  const rest = omitThemingProps(props);
  const __css = useTextStyleConfig(props);
  return <ChakraP ref={ref} __css={__css} {...rest} {...textAnatomy.root.attrs} data-size={props.size} />;
});
